var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { LoadingSpinner } from 'Permafrost/index';
import { StyledButton } from './Button.styles';
export function Button(props) {
    const { busy, children, className, disabled, id, onClick, onFocus, role, style, tabindex, type, variant = 'default' } = props, rest = __rest(props, ["busy", "children", "className", "disabled", "id", "onClick", "onFocus", "role", "style", "tabindex", "type", "variant"]);
    return (React.createElement(StyledButton, Object.assign({ "aria-disabled": busy, "aria-label": props['aria-label'], "aria-pressed": props['aria-pressed'], "aria-selected": props['aria-selected'], className: classNames(variant, className, {
            blue: variant === 'primary' || variant === 'cta',
            busy,
        }), "data-cy": props['data-cy'], "data-for": props['data-for'], "data-tip": props['data-tip'], disabled: disabled, id: id, onClick: busy ? undefined : onClick, onFocus: onFocus, role: role, style: style, tabIndex: tabindex, type: type || 'button' }, rest),
        busy && React.createElement(LoadingSpinner, { size: "0.9em", style: { marginRight: '0.5em' } }),
        children));
}
//# sourceMappingURL=Button.js.map